import SettingList from "../pages/setting/Setting";
import SiteSettings from "../pages/setting/site_setting";
import CommentSettings from "../pages/setting/comment_settng";
import SEOSettings from "../pages/setting/seo_setting";
import CategorySettings from "../pages/setting/categorySetting";
import SeoSettings from "../pages/setting/seo_setting";

const settingRoutes = [
  {
    path: "setting",
    element: <SettingList />,
  },
  {
    path: "site_setting",
    element: <SiteSettings />,
  },
  {
    path: "comment_setting",
    element: <CommentSettings />,
  },
  {
    path: "category_setting",
    element: <CategorySettings />,
  },
  {
    path: "seo_setting",
    element: <SeoSettings />,
  },
  
];

export default settingRoutes;